import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        status: null,
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/authen/password/index.js